import React, { useState } from "react";
import SubHeader from "../general/SubHeader";
import axios from 'axios'

const Contact = () => {
const[form,setForm] = useState({
  name:'',
  email:'',
  phone:'',
  message:'',
})
  const [responseMessage, setResponseMessage] = useState("");


const handleChange = (e) => {
  const { name, value } = e.target;

  setForm((prev) => ({
    ...prev,
    [name]: value
  }));
};



const handleSubmit = async (e) => {
  e.preventDefault();
 setResponseMessage("");
  try {

    const res = await axios.post('https://api.swalokgroup.com/api/contact',form)
  
 
    setResponseMessage("Form submitted successfully!");
    setTimeout(() => setResponseMessage(""), 1000);

    setForm({
      name: '',
      email: '',
      phone: '',
      message: '',
    });

  } catch (error) {
    console.error(error);
    setResponseMessage("Something wenrt wrong!.");
    setTimeout(() => setResponseMessage(""), 1000);
  }
};

  return (
    <>
      <SubHeader message="Contact Us" />

      {/* Contact details section */}
      <section className="my-5">
        <div className="container d-lg-flex d-md-flex d-block justify-content-center text-center">
          <div className="px-lg-5 px-4 py-4 border-right">
            <i className="fs-4 fa-regular fa-map text-muted"></i>
            <p className="my-1 fw-semibold">Address:</p>
            <p className="text-muted">
              151A/38, Tagore Town,
              <br />
              Prayagraj, Uttar Pradesh 211002
            </p>
          </div>

          <div className="px-lg-5 px-4 py-4 border-right">
            <i className="fs-4 fa-solid fa-mobile-screen-button text-muted"></i>
            <p className="my-1 fw-semibold">Phone:</p>
            <p className="text-muted">+91 6307697174</p>
          </div>

          <div className="px-lg-5 px-4 py-4">
            <i className="fs-4 fa-regular fa-envelope text-muted"></i>
            <p className="my-1 fw-semibold">Email:</p>
            <p className="text-muted">swalokgroup@gmail.com</p>
          </div>
        </div>
      </section>
      {/* Contact details section ends */}

      {/* Form Section */}
      <section className="my-5">
        <div className="container text-center px-4">
          <div className="sec-subheading">
            <hr />
            <span>Have Questions in mind ?</span>
            <hr />
          </div>
          <p className="sec-heading">Contact Now</p>

          <form  onSubmit={handleSubmit} className="row g-3 bg-body-tertiary px-4 py-5 mt-4 col-lg-8 col-md-10 col-12 mx-auto text-start">
            <div className="col-12">
              <input
                type="text"
                className="form-input"
                id="inputText"
                placeholder="Your Name"
                name="name"
                value={form.name}
                   onChange={handleChange}
                   required
              />
            </div>

            <div className="col-12">
              <input
                type="email"
                className="form-input"
                id="inputEmail"
                placeholder="Your Email"
                 name="email"
                value={form.email}
                  onChange={handleChange}
                  required
              />
            </div>
            <div className="col-12">
              <input
                type="tel"
                className="form-input"
                id="inputAddress"
                placeholder="Your Phone"
                 name="phone"
                value={form.phone}
                  onChange={handleChange}
                  required
              />
            </div>
            <div className="col-12">
              <textarea
                className="form-input"
                id="inputMessage"
                placeholder="Write Message Here"
                style={{ height: "10em" }}
                 name="message"
                value={form.message}
                  onChange={handleChange}
                  required
              ></textarea>
            </div>
            <div className="col-lg-3 col-12">
              <button type="submit" className="banner-btn w-100">
                Send Message
              </button>
            </div>
          </form>



        </div>
      </section>
      {/* Form Section ends */}


        {responseMessage && (
          <div className="response-message d-flex justify-content-between">
            <p className="my-0 mx-auto">{responseMessage}</p>
            <p
              className="my-0 cursor-pointer"
              onClick={() => setResponseMessage(false)}
            >
              <i className="fa-solid fa-xmark"></i>
            </p>
          </div>
        )}

      {/* Map Section */}
      <section className="my-5">
        <div className="container px-4">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d900.641152378969!2d81.86389609999999!3d25.452815800000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399acb003929345f%3A0x742e10b4a88380f4!2sSWALOK%20GROUP!5e0!3m2!1sen!2sin!4v1735569876657!5m2!1sen!2sin"
            className="w-100 border-0"
            height="500"
            allowfullscreen=""
            title="SwalokGroupMap"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>
      {/* Map Section ends */}
    </>
  );
};

export default Contact;
